import scrollTarget from './scrollTarget';

export default function guidesPagination() {
  const $guides = $('.p-guides');
  const setCookie = () => {
    document.cookie = 'guidesPagination=true; path=/; samesite=lax';
  };
  const removeCookie = () => {
    document.cookie = 'guidesPagination=; max-age=0; path=/; samesite=lax';
  };

  if ($guides.length === 0) {
    removeCookie();
    return;
  }

  if (
    document.cookie
      .split(';')
      .some(item => item.includes('guidesPagination=true'))
  ) {
    removeCookie();
    scrollTarget($guides, 500);
  }

  $guides.on('click', '.p-guides__pagination a', () => {
    setCookie();
  });
}
